import Vue from 'vue'
import VueRouter from 'vue-router'
import empty from '@404'
import Index from '../components/Payment/Index.vue'
import PayDeposit from '../components/PayDeposit/Index.vue'
Vue.use(VueRouter)

const routes = [
    { path: '/', name: 'empty', component: empty },
    { path: '/payment/:orderNo/:sn/:source?', name: 'empty', component: Index }, // source 1 经销商
    { path: '/payDeposit/:invitedUserId/:meetingNo/:source', name: 'deposit', component: PayDeposit },
]
const router = new VueRouter({
    mode: 'history',
    // mode: 'hash',
    base: "/",
    routes
})

export default router
